/*

jv.Common.Modal
===============

Directive to create a modal dialog box.
Associated scss: common/_modal.scss

Note: make sure your application has access to /web/WEB-INF/pages/htm/common/modal.jsp.

Usage
-----

```
<div jv-modal jv-modal-center jv-modal-hide="" ng-show="" [jv-modal-class=""] ng-cloak>
	<div class="jv-modal-header">
		<h2>Header</h2>
	</div>
	<div class="jv-modal-content">
		<p>Content</p>
	</div>
</div>
```

Options
-------

-	`jv-modal-hide`:
	How to hide the modal. This function is used for the click event
	of the close button

-	`ng-show`:
	When to show/hide the modal.

-	`jv-modal-class`:
	*Deprecated* Apply a class to the inner modal element

*/

angular.module('jv.Common.Modal', [])

.value('modalTemplateUrl', '../htm/common/modal.html')
.value('modalZIndex', 11000)

.directive('jvModal', [

	'$window', '$timeout', 'modalTemplateUrl', 'modalZIndex', '$rootScope',

	function($window, $timeout, tplUrl, zIndex, $rootScope) {

		var $overlay = $('<div class="jv-modal-overlay animate"/>'),
			$body = $($window.document.body),
			stack = [],
			hideTimer,
			hideOverlayTimer;

		$body.append($overlay);

		// detect whether animation is supported
		try {
			angular.module('ngAnimate');
		} catch (e) {
			if (angular.version.major === 1 && Number(String(angular.version.minor) + String(angular.version.dot)) < 15) {
				$overlay.removeClass('animate');
			}
		}

		$rootScope.$on('resetJvModal', function() {
			stack = [];
			$body.removeClass('jv-modal-visible');
			$overlay.removeClass('visible');
		});

		return {
			templateUrl: tplUrl,
			replace: true,
			transclude: true,
			controller: ['$element', '$attrs', '$transclude', function($tpl, $attrs, $transclude) {
				$transclude(function(clone) {
					$tpl.find('.jv-modal-header').replaceWith(clone.filter('.jv-modal-header'));
					$tpl.find('.jv-modal-content').replaceWith(clone.filter('.jv-modal-content'));
					$tpl.find('.jv-modal').addClass($attrs.jvModalClass);
				});
			}],
			compile: function(tElement, tAttrs) {
				tElement.find('.jv-modal-close').attr('ng-click', tAttrs.jvModalHide);
				return function(scope, element, attrs) {
					/*
					Fix for iframe z-index issue on IE. Bug 20623 - NV
					*/
					if(scope.isIE && scope.isIE()){
						$('.jv-modal-overlay').append('<iframe class="cover" style="position: absolute;border: none;top: 0;left: 0;height: 100%;width: 100%;z-index: -1;" src="about:blank"></iframe>');
					}
					var showExpr = attrs.jvModal || attrs.ngShow;
					var initialized = false;
					scope.$watch(showExpr, function(isShown, prev) {
						if (isShown === prev && initialized) {
							// don't do anything on repeated changes, it messes stuff up :/
							return;
						}

						if (initialized) {
							$timeout.cancel(hideTimer);
							$timeout.cancel(hideOverlayTimer);
						}

						if (isShown) {
							initialized = true;
							stack.push(element);
							$body.addClass('jv-modal-visible');
							$timeout(function(){
								if (angular.isDefined(attrs.jvModalCenter) && element.children().innerHeight() < $window.innerHeight) {
									element.css('margin-top', -element.children().innerHeight()/2);
									element.removeClass('jv-modal-container').addClass('jv-modal-container-center');
								}
							});

							// FIXIT: Pranav - 01/30.
							// With upgrade to angular 1.2.9, there was an issue with the modal being hidden
							// The main reason was the presence of style="display:none;" in modal.jsp which Chris
							// mentioned was a hack for animations to work in Angular 1.1.5. So the plan is to clean
							// this up once all applications are on 1.2.9. With this change, modal works on all version on
							// angular.

							element.css('display', 'block');

							// fix for angular version <= 1.1.x
							if (angular.version.major === 1 && angular.version.minor <= 1) {
								element.removeClass('ng-hide');
							}

							element.css('z-index', stack.length * 100 + zIndex);
							$overlay.css('z-index', stack.length * 100 + zIndex - 50);
							$timeout(function() {
								$overlay.addClass('visible');
								element.scrollTop(0); // reset saved (by browser) scroll position
								element.find('[autofocus]:first').trigger('focus');
							});
						}
						else if (stack.length > 0 && initialized) {
							stack.pop();
							$overlay.css('z-index', stack.length * 100 + zIndex - 50);
							if (stack.length === 0) {
								hideTimer = $timeout(function() {
									$body.removeClass('jv-modal-visible');
									element.css('display', 'none');
								}, 400); // hard-coded timeout is for css transition
								hideOverlayTimer = $timeout(function() {
									// put this in a timeout so class isn't removed and added
									// when a modal is hidden and another is immediately shown
									$overlay.removeClass('visible');
								}, 10);
							}
						}
					});
				};
			}
		};
	}
]);
